import { QueryHookOptions, useQuery } from '@apollo/react-hooks'
import { AMENITIES_QUERY } from 'apollo'
import { merge } from 'merge-anything'

const DEFAULTS = {
  variables: {
    query: {},
  },
}

export const useAmenitiesQuery = (options: QueryHookOptions<any, any> = {}) =>
  useQuery(AMENITIES_QUERY, merge(options, DEFAULTS))
